import React from "react";
import Page from "../../common/page/Page";
import useTranslationEmailSubscription from "../useTranslationEmailSubscription";
import CandidateUnsubscriptionBlock from "./CandidateUnsubscriptionBlock";
import useShowLoader from "../../common/loading-widgets/useShowLoader";
import { useParams } from "react-router";

export default function CandidateUnsubscriptionPage(/*props*/) {
  // Fetch the email provided in the url params.
  const urlParams = useParams();
  const email = urlParams.email;

  const { t, loading: tLoading } = useTranslationEmailSubscription();
  useShowLoader(tLoading, "CandidateUnsubscriptionPage");

  return (
    <Page className="CandidateUnsubscriptionPage">
      <Page.Title
        text={t("email-subscription:email_unsubscription_candidate_title")}
        loading={tLoading}
      />
      <Page.Content>
        <CandidateUnsubscriptionBlock email={email} />
      </Page.Content>
    </Page>
  );
}
